
 
const DrillFunctions = {

    GetDrillText(drills) {
        if (drills.length > 0){
            let returnText = '';
            for (let i = 0; i < drills.length; i++) {
              if (returnText.length === 0){
                returnText = ` * Drill exists: ${drills[i].drill_column}`;
              } else {
                returnText += `, ${drills[i].drill_column}`;
              }
            }
            return returnText;
        } else {
            return '';
        }
    }

}

export default DrillFunctions;